module.exports = __webpack_public_path__ + "img/IMG_3528.bce20e90.jpg";